import Portal from "@/components/Layout/Portal.vue";
import Terms from "@/components/Portal/Terms.vue";
import Redemption from "@/components/Portal/Redemption.vue";
import ShowOrder from "@/components/Portal/ShowOrder.vue";
const portalRoutes = [
    {
        path: '/admin',
        component: Portal,
        children: [
            { name: 'terms', path: '/Terms', component: Terms },
            { name: 'redemption', path: '/', component: Redemption },
            { name: 'redemption.order.show', path: '/order/:slug', component: ShowOrder },
        ]
    }
];
export { portalRoutes };
